import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const state = {
  activeIndex:0,
  keepAlive: []
}
const mutations = {
  setKeepAlive: (state, keepAlive) => {
    state.keepAlive = keepAlive
  },
}
const getters = {
  keepAlive: state => state.keepAlive
}
export default new Vuex.Store({
  state,
  mutations,
  getters,
  modules: {}
});



// WEBPACK FOOTER //
// ./src/store/store.js